const CONJUNCTIONS = ['and', 'the', '&', 'for', 'of', 'in', 'to', 'with']

export const getIdentifierPrefix = (name: string) => {
  if (!name?.trim()?.length) return null

  let value: string

  const nameChunks = name
    .trim()
    .split(' ')
    .filter((chunk) => chunk.trim().length > 2)
    .filter((chunk) => !CONJUNCTIONS.includes(chunk.trim().toLowerCase()))

  if (nameChunks.length === 1) {
    value = nameChunks[0].substring(0, 5).toUpperCase()
  } else {
    value = nameChunks
      .map((chunk) => chunk[0].toLowerCase())
      .slice(0, 5)
      .join('')
      .toUpperCase()
  }

  return value
}
